import type { MantineThemeOverride } from "@mantine/core";

export const typography: MantineThemeOverride = {
  fontFamily: "Geist, sans-serif",
  fontFamilyMonospace: "Geist Mono",

  headings: {
    fontFamily: "Geist, sans-serif",
    sizes: {
      h1: {
        fontSize: "34px",
        lineHeight: "42px",
        fontWeight: "600",
      },
      h2: {
        fontSize: "26px",
        lineHeight: "36px",
        fontWeight: "600",
      },
      h3: {
        fontSize: "22px",
        lineHeight: "32px",
        fontWeight: "600",
      },
      h4: {
        fontSize: "18px",
        lineHeight: "28px",
        fontWeight: "600",
      },
      h5: {
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: "600",
      },
      h6: {
        fontSize: "14px",
        lineHeight: "20px",
        fontWeight: "600",
      },
    },
  },

  fontSizes: {
    xs: "12px",
    sm: "14px",
    md: "16px",
    lg: "18px",
    xl: "20px",
  },

  lineHeights: {
    xs: "18px",
    sm: "22px",
    md: "26px",
    lg: "28px",
    xl: "32px",
  },
};
